module.exports = __webpack_public_path__ + "static/media/hero_armor_background.34afd81e.jpg";